// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3p4dT","footer":"ModalError_footer__2k2DX"};